import React from "react"
import { Box, Typography } from "@mui/material"

export default function numSearchesColumn() {
    return {
        name: "num_searches", label: "Nº Searches",
        options: {
            customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
                <Typography>{value}</Typography>
            </Box>
        }
    }
}